/**
 * TimelineEndNode - Arrow indicating continuation of timeline
 * Uses React Flow handle for edge connections
 */

import { memo } from 'react'
import { Handle, Position } from '@xyflow/react'
import './TimelineEndNode.css'

function TimelineEndNodeComponent() {
  return (
    <div className="timeline-end-node">
      {/* Top handle for receiving connection from last card */}
      <Handle
        type="target"
        position={Position.Top}
        id="top"
        className="timeline-end-node__handle"
      />
      <svg
        className="timeline-end-node__arrow"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 16L6 10H18L12 16Z" />
      </svg>
    </div>
  )
}

export const TimelineEndNode = memo(TimelineEndNodeComponent)
